// Vrati sve podkategorije za glavnu kategoriju (3 glavne)
export const SECOND_CATEGORY_REQUEST = 'SECOND_CATEGORY_REQUEST';
export const SECOND_CATEGORY_SUCCESS = 'SECOND_CATEGORY_SUCCESS';
export const SECOND_CATEGORY_FAIL = 'SECOND_CATEGORY_FAIL';
